export const GET_WORKORDERSTATE = 'GET_WORKORDERSTATE'
export const GET_WORKORDERSTATE_EXITO = 'GET_WORKORDERSTATE_EXITO'
export const GET_WORKORDERSTATE_ERRROR = 'GET_WORKORDERSTATE_ERROR'
